import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import "../CSS/Global.css";

const RefundPolicy = () => {
  return (
    <>
      <Header />
      <div className="legal-page-shell">
        <div className="refund-policy legal-doc">
          <h1>Refund &amp; Cancellation Policy</h1>
          <p className="legal-doc-meta">
            This policy applies to bookings and paid orders placed on <strong>Filmekee.com</strong>. It works together with our <Link to="/terms-condition">Terms &amp; Conditions</Link> and any vendor-specific notes shown on a listing before you pay.
          </p>

          <h2>1. Cancellation window (customer-initiated)</h2>
          <p>
            You may <strong>request cancellation</strong> of a booking only if we receive your request <strong>at least twelve (12) hours before</strong> the <strong>scheduled start</strong> of the booking (for date-range bookings, this means twelve (12) hours before the start date/time of the range as confirmed on your order).
          </p>
          <p>
            <strong>Inside twelve (12) hours:</strong> Cancellation requests made <strong>within twelve (12) hours</strong> of the scheduled start are <strong>not accepted</strong>. The booking remains valid and fees already captured may be non-refundable except where required by law or at Filmekee’s discretion in exceptional cases (e.g. documented vendor no-show).
          </p>

          <h2>2. Cancellation fee</h2>
          <p>
            When a cancellation is <strong>approved</strong> under Section 1, a <strong>twenty percent (20%) cancellation fee</strong> is deducted from the refundable amount. You receive a refund of approximately <strong>eighty percent (80%)</strong> of the eligible booking value to the original payment method or wallet, subject to processing times below. Taxes or gateway charges may be handled as per applicable rules and payment provider terms.
          </p>

          <h2>3. How to request cancellation</h2>
          <p>
            Use the cancel option in your order or booking area on Filmekee, or contact support with your booking / transaction ID and registered email. We confirm eligibility based on the timestamp of your request relative to the scheduled booking start.
          </p>

          <h2>4. Vendor cancellations &amp; failures</h2>
          <p>
            If a vendor cancels a confirmed booking or cannot fulfil it, we will work with you and the vendor on a reschedule or refund of amounts paid for the affected booking, in line with platform rules and payment capture status.
          </p>

          <h2>5. Damaged, wrong, or unusable items</h2>
          <p>
            For tangible deliveries, report issues with photos and your order ID within a reasonable time from receipt. Eligible cases may qualify for replacement, partial refund, or full refund of the affected items, after review. This does not override the twelve-hour rule for <em>scheduled service bookings</em> where no physical return applies.
          </p>

          <h2>6. Processing time</h2>
          <p>
            Approved refunds typically appear within <strong>7–14 business days</strong>, depending on your bank or card issuer. Wallet or UPI timelines may be shorter.
          </p>

          <h2>7. Disputes</h2>
          <p>
            Filmekee may mediate between customer and vendor. Decisions aim to reflect these policies, listing terms, and conversation or evidence available in the platform.
          </p>

          <p>
            <strong>Last updated:</strong> 31 March 2026 · <strong>Support:</strong> support@filmekee.com
          </p>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;
